import React, { FC } from 'react';
import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

interface Props {
  className?: string;
}

export const LoadingOverlay: FC<Props> = (props) => {
  return (
    <Container data-test="loading-overlay" className={props?.className}>
      <Spinner animation="border" />
      {props.children}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 2em;
  padding-bottom: 2em;
  max-height: calc(100% - 2em);
  overflow: hidden;
  background: rgba(0, 0, 0, 0.01);
`;
